export enum SubscriptionManagePricesMethodsEnum {
  SUBSCRIPTION = 'subscription',
  PRICE_LIST = 'price_list',
}
